rs.module("ui/controls/address-autocomplete",

    [
        "common/select-helper",
        "common/perfect-scrollbar",
        "common/visibility"
    ],

    function (selectHelper, perfectScrollbar, visibility) {

        var scrollbars = [];

        // Initialize the module
        function initialize(avasEnabled, jsSelectors, ajaxUrl, cssClasses, fundState, startDisabled, usa, isValid) {
            var container = jsSelectors.parentSelector ? $.js(jsSelectors.parentSelector) : $;

            var addressSearch = container.js(jsSelectors.addressSearch); // this is also address line 1
            var resultsWindow = container.js(jsSelectors.resultsWindow, { required: false });
            var searchResultLink = resultsWindow.js(jsSelectors.searchResultLink, { required: false, multiple: true });
            var addressLine2 = container.js(jsSelectors.addressLine2);
            var city = container.js(jsSelectors.city);
            var cityHidden = container.js(jsSelectors.cityHidden);
            var state = container.js(jsSelectors.state);
            var stateSelectHelper = selectHelper.getHelper(state);
            var stateHidden = container.js(jsSelectors.stateHidden);
            var zipCode = container.js(jsSelectors.zipCode);
            var zipCodeHidden = container.js(jsSelectors.zipCodeHidden);
            var country = container.js(jsSelectors.country);
            var countrySelectHelper = selectHelper.getHelper(country);
            var countryHidden = container.js(jsSelectors.countryHidden);
            var enterManually = container.js(jsSelectors.enterManually);
            var avasOverride = container.js(jsSelectors.avasOverride, { required: false });
            var avasOverrideHidden = container.js(jsSelectors.avasOverrideHidden, { required: false });

            //trigger the enterManually and country change events when they are enabled
            //https://stackoverflow.com/a/29631624
            var observer = new MutationObserver(function (mutations) {
                for (var i = 0, mutation; mutation = mutations[i]; i++) {
                    if (mutation.attributeName == 'disabled' && !mutation.target.disabled) {
                        enterManually.trigger("change");
                        country.trigger("change");
                    }
                };
            });

            // Observe enterManually change
            observer.observe(enterManually[0], { attributes: true });

            if (avasEnabled) {
                addressSearch.keyup(_.debounce(_initiateSearch, 200));

                if (countryHidden.val() && countryHidden.val() != usa && country.val() != usa) {
                    enterManually.setChecked();
                    enterManually.prop("disabled", true);
                    avasOverride.setChecked();
                    avasOverride.prop("disabled", true);
                    avasOverrideHidden.val(true);
                    avasOverrideHidden.prop("disabled", false);
                }

                // skip if messages are in the eventBanner or field validations appear
                // ie business errors/warnings occured on postback, so this is not the initial load
                if (isValid && startDisabled) {
                    setControlsEnabled(false);
                }
                else {
                    setControlsEnabled(enterManually.is(":checked"));
                }
            }
            else {
                // skip if messages are in the eventBanner or field validations appear 
                // ie business errors/warnings occured on postback, so this is not the initial load
                if (isValid)
                {
                    setControlsEnabled(!startDisabled);
                }
                enterManually.prop("disabled", true);
                visibility.hide(enterManually);
                visibility.hide(enterManually.closest(".form-group"));
                visibility.hide(avasOverride);
                visibility.hide(avasOverride.closest(".form-group"));
            }

            // initiate a search
            function _initiateSearch() {
                var isEnteredManually = enterManually.is(":checked");
                if (!isEnteredManually) {
                    addressLine2.val(null);
                    city.val(null);
                    cityHidden.val(null);
                    stateSelectHelper.setValue(null);
                    stateHidden.val(null);
                    zipCode.val(null);
                    zipCodeHidden.val(null);
                                        
                    if (addressSearch.val().length >= 3) {
                        _showResultsWindow();

                        $.get(ajaxUrl, { query: addressSearch.val(), fundState: fundState }).done(function (results) {
                            resultsWindow.html(results);

                            searchResultLink = resultsWindow.js(jsSelectors.searchResultLink, { required: false, multiple: true });
                            searchResultLink.each(function () {
                                $(this).on("click", function () {

                                    //if entries > 1, make another call with the selected address
                                    if ($(this).data("entries") > 1) {
                                        var selected = $(this).data("addressline1") + " " + $(this).data("addressline2") + " (" + $(this).data("entries") + ") " + $(this).data("city") + " " + $(this).data("stateval") + " " + $(this).data("zipcode")

                                        $.get(ajaxUrl, { query: addressSearch.val(), fundState: fundState, selected: selected }).done(function (results2) {
                                            resultsWindow.html(results2);

                                            searchResultLink = resultsWindow.js(jsSelectors.searchResultLink, { required: false, multiple: true });
                                            searchResultLink.each(function () {
                                                $(this).on("click", function () {
                                                    setControlsFromResult($(this));
                                                });
                                            });
                                        });
                                    }
                                    else {
                                        setControlsFromResult($(this));
                                    }
                                })
                            });
                        })
                    }
                    else if (addressSearch.val().length == 0) {
                        if (resultsWindow.is(":visible")) {
                            resultsWindow.toggleClass(cssClasses.visible, false);
                            $(document).off("mouseup", _clickDocument);
                        }
                    }
                }
            }

            // Set the controls from the results
            function setControlsFromResult(result) {
                addressSearch.val(result.data("addressline1"));
                addressLine2.val(result.data("addressline2"));
                city.val(result.data("city"));
                cityHidden.val(result.data("city"));
                stateSelectHelper.setValue(result.data("statecd"));
                stateHidden.val(result.data("statecd"));
                zipCode.val(result.data("zipcode"));
                zipCodeHidden.val(result.data("zipcode"));
                resultsWindow.toggleClass(cssClasses.visible, false);
            }

            // display the results window
            function _showResultsWindow() {
                if (!resultsWindow.is(":visible")) {
                    resultsWindow.toggleClass(cssClasses.visible, true);
                    $(document).on("mouseup", _clickDocument);
                }
            }

            // Handler for clicking the document, outside of the visible results window
            function _clickDocument(e) {
                // close and detach handler
                if (!resultsWindow.is(e.target) && resultsWindow.has(e.target).length === 0) {
                    resultsWindow.toggleClass(cssClasses.visible, false);
                    $(document).off("mouseup", _clickDocument);
                }
            }

            // update the values of enterManually and avasOverride when the country changes
            country.change(function () {
                if (avasEnabled) {
                    if (country.val() != usa) {
                        enterManually.setChecked();
                        enterManually.prop("disabled", true);
                        avasOverride.setChecked();
                        avasOverride.prop("disabled", true);
                        avasOverrideHidden.val(true);
                        avasOverrideHidden.prop("disabled", false);
                    }
                    else {
                        avasOverride.prop("disabled", false);
                        enterManually.prop("disabled", false);
                    }
                }
            });

            // enable/disable avas related controls when the value changes
            enterManually.change(function () {
                if (avasEnabled) {
                    var isEnteredManually = enterManually.is(":checked");
                    if (!isEnteredManually) {
                        addressSearch.val(null);
                        addressLine2.val(null);
                        city.val(null);
                        cityHidden.val(null);
                        stateSelectHelper.setValue(null);
                        stateHidden.val(null);
                        zipCode.val(null);
                        zipCodeHidden.val(null);
                        countrySelectHelper.setValue(usa);
                        countryHidden.val(usa);
                    }
                    setControlsEnabled(isEnteredManually);
                }
            });

            // Update the avasOverrideHidden value when the checkbox changes
            avasOverride.change(function () {
                avasOverrideHidden.val(avasOverride.prop("checked"));
            });

            // enable or disable the visible controls
            function setControlsEnabled(enabled) {
                city.prop("disabled", !enabled);
                cityHidden.prop("disabled", enabled);
                state.prop("disabled", !enabled);
                stateSelectHelper.setDisabled(!enabled);
                stateHidden.prop("disabled", enabled);
                zipCode.prop("disabled", !enabled);
                zipCodeHidden.prop("disabled", enabled);
                country.prop("disabled", !enabled);
                countrySelectHelper.setDisabled(!enabled);
                countryHidden.prop("disabled", enabled);
            }
        }

        // search has completed, setup scrollbars
        function searchCompleted(jsSelectors) {
            for (var scrollbar of scrollbars) {
                scrollbar.destroy();
            }
            scrollbars = [];

            // Needs to be in setTimeout so the perfect scrollbar will show immediately
            setTimeout(function () {
                // setup perfect scrollbars
                var scrollContents = $.js(jsSelectors.scrollContent, { multiple: true, required: false });
                for (var scrollContent of scrollContents) {
                    scrollbars.push(perfectScrollbar.createInstance(scrollContent,
                        {
                            suppressScrollX: true,
                        }));
                }
            }, 0);
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            searchCompleted: searchCompleted
        };

        return exports;
    }
);